import {Component, EventEmitter, OnInit, Output} from '@angular/core';
import {FinancialOrganisationService} from '@cas-hub/acabim-financial-client';
import {FinancialManagementService} from '../../../../pages/financial/_services/financial-management.service';
import {FinancialSetting} from '../../../../pages/financial/_models/financial-management.model';

@Component({
  selector: 'acabim-admin-onboarding-financial-enable',
  templateUrl: './onboarding-financial-enable.component.html',
  styleUrls: ['../styles.scss', './onboarding-financial-enable.component.scss']
})
export class OnboardingFinancialEnableComponent implements OnInit {

  isLoading = false;
  active = false;
  @Output() completed = new EventEmitter<string>();

  constructor(
      private readonly financialPreferencesService: FinancialOrganisationService,
      private readonly financialService: FinancialManagementService,

  ) { }

  ngOnInit(): void {
    this.getPreferences();
  }

  getPreferences(): void {
    this.isLoading = true;
    this.financialPreferencesService.isEnabled().subscribe(data => {
      if (data) {
        this.active = data.status > 0;
        this.isLoading = false;
        if (this.active) {
          this.completed.emit('enabled');
        } else {
          this.completed.emit('disabled');
        }
      }
    });
  }

  submit(value: boolean) {
    const payload: FinancialSetting = {
      enable: value ? 1 : 0
    };
    this.financialService.setCurrentSettings(payload).subscribe(res => {
      this.getPreferences();
    });
  }

}
